<template>
    <v-dialog v-model="dialog" max-width="40%" @keydown.esc="cancel">
        <v-card>
            <v-card-title class="headline">
                {{ title }}
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <p>
                    {{ p1 }}
                </p>
                <p v-if="reseller">
                    <strong>Parceiro: {{ reseller.trade_name }}</strong>
                </p>
                <p>
                    {{ p2 }}
                </p>
            </v-card-text>
            <v-card-actions>
                <v-btn class="col" text @click="dialog = false">
                    {{ $t('actions.reseller.notifyCustomers.close') }}
                </v-btn>
                <v-divider vertical=""></v-divider>
                <v-btn
                    class="col"
                    color="green darken-1"
                    text
                    @click="save"
                    :loading="saving"
                >
                    {{ $t('actions.reseller.notifyCustomers.save') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data: () => {
        return {
            dialog: false,
            reseller: undefined,
            loading: true,
            sorting: true,
            saving: false,
        }
    },

    watch: {
        dialog() {
            if (this.dialog === false) {
                this.reseller = undefined
            }
        },
    },

    computed: {
        title() {
            return this.reseller && this.reseller.notify_customers
                ? this.$t('actions.reseller.notifyCustomers.title2')
                : this.$t('actions.reseller.notifyCustomers.title')
        },
        p1() {
            return this.reseller && this.reseller.notify_customers
                ? this.$t('actions.reseller.notifyCustomers.p3')
                : this.$t('actions.reseller.notifyCustomers.p1')
        },
        p2() {
            return this.reseller && this.reseller.notify_customers
                ? this.$t('actions.reseller.notifyCustomers.p4')
                : this.$t('actions.reseller.notifyCustomers.p2')
        },
        success() {
            return this.reseller && this.reseller.notify_customers
                ? this.$t('actions.reseller.notifyCustomers.success2')
                : this.$t('actions.reseller.notifyCustomers.success')
        },
    },

    methods: {
        open(reseller) {
            this.dialog = true
            this.reseller = reseller
        },

        async save() {
            this.saving = true
            let res = await this.reseller.notifyCustomers(this.reseller.id)
            this.saving = false
            this.dialog = false

            if (!res) return

            this.$emit('modelChanged', this.reseller)
            this.$bus.$emit('notify', 'success', this.success)
        },
    },
}
</script>

<style></style>
